import { render } from "./NewsBlock.vue?vue&type=template&id=a89e9ca8&scoped=true"
import script from "./NewsBlock.vue?vue&type=script&lang=js"
export * from "./NewsBlock.vue?vue&type=script&lang=js"

import "./NewsBlock.vue?vue&type=style&index=0&id=a89e9ca8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a89e9ca8"]])

export default __exports__